import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "native-base";

import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
import { webFont } from "../../../../Universal/API/API";
import PressableWrapp from "../../../../Universal/Buttons/PressableReact/PressableWrapp";

type FilterSlideHeaderProps = {
  title: string;
  canClear: boolean;
  resultCount: number;
  onClear: () => void;
  children?: React.ReactNode;
};

const FilterSlideHeader: React.FC<FilterSlideHeaderProps> = ({
  title,
  canClear,
  resultCount,
  onClear,
  children,
}) => {
  const { scaleAll } = useAppContext();
  const styles = React.useMemo(() => createStyles(scaleAll), [scaleAll]);

  return (
    <View style={styles.outer}>
      <View style={styles.shell}>
        <View style={styles.hero}>
          <View style={styles.heroTextBlock}>
            <Text selectable={false} style={styles.title}>
              {title}
            </Text>
            <Text selectable={false} style={styles.subtitle}>
              Настройте фильтры и выберите нужную позицию.
            </Text>
          </View>

          <View style={styles.controlsRow}>
            <View style={styles.countChip}>
              <Text selectable={false} style={styles.countChipText}>
                {`Найдено ${resultCount}`}
              </Text>
            </View>

            <PressableWrapp
              onPress={canClear ? onClear : undefined}
              activeOpacity={canClear ? 0.86 : 1}
              disabled={!canClear}
              style={[
                styles.clearButton,
                !canClear ? styles.clearButtonDisabled : null,
              ]}
            >
              <Text selectable={false} style={styles.clearButtonText}>
                Очистить
              </Text>
            </PressableWrapp>
          </View>
        </View>

        <View style={styles.filtersWrap}>{children}</View>
      </View>
    </View>
  );
};

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    outer: {
      width: "100%",
      paddingTop: 42 * scaleAll,
      paddingBottom: 12 * scaleAll,
    },
    shell: {
      width: "100%",
      maxWidth: 1560 * scaleAll,
      alignSelf: "center",
      paddingHorizontal: 16 * scaleAll,
    },
    hero: {
      width: "100%",
      paddingHorizontal: 4 * scaleAll,
      paddingTop: 10 * scaleAll,
    },
    heroTextBlock: {
      marginTop: 0,
    },
    title: {
      fontFamily: webFont("Inter"),
      fontSize: 22 * scaleAll,
      lineHeight: 27 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      maxWidth: 1120 * scaleAll,
      marginBottom: 4 * scaleAll,
    },
    subtitle: {
      fontFamily: webFont("Inter"),
      fontSize: 14 * scaleAll,
      lineHeight: 19 * scaleAll,
      color: "#6F6A63",
      fontWeight: "500",
    },
    controlsRow: {
      marginTop: 14 * scaleAll,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: 10 * scaleAll,
    },
    countChip: {
      minHeight: 42 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      backgroundColor: "#EAF4FF",
      borderWidth: 1,
      borderColor: "#CFE5FF",
      justifyContent: "center",
    },
    countChipText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#0B5CAD",
      fontWeight: "600",
    },
    clearButton: {
      minHeight: 42 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#E7E1D8",
      justifyContent: "center",
    },
    clearButtonDisabled: {
      opacity: 0.45,
    },
    clearButtonText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#1E1E1E",
      fontWeight: "600",
    },
    filtersWrap: {
      marginTop: 18 * scaleAll,
      gap: 12 * scaleAll,
    },
  });

export default React.memo(FilterSlideHeader);
